let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k1EYw")).then(() => parcelRequire('9CE1Z'));